import React from 'react';
import './Contact.css';
import "aos/dist/aos.css";
import { AiFillFacebook, AiFillLinkedin } from 'react-icons/ai';



const Contact = () => {


    return (
        <div id="contact-section" className="container skill contact-section">
            <div className="back-line d-flex align-items-center skill-title">
                <div className="front-box d-flex align-items-center">
                    <p className="d-flex align-items-center">Contact</p>
                </div>
            </div>


            <div className="row">
                <div className="col-12 col-md-6">
                    <article className="contact-me">
                        <p>
                            I am interested in working with any company that thinks my skill will be helpful for them. If you are looking for someone like me, please let me know. Or you can just 'say hi' to me.
                        </p>

                        <a className="btn-lg" href="mailto:engr.shakilahmed1@gmail.com" >Contact Me</a>
                    </article>

                </div>
                <div className="col-12 col-md-6">
                    <div className="contact-add">
                        <h3>Email</h3>
                        <p><a href="mailto:engr.shakilahmed1@gmail.com">engr.shakilahmed1@gmail.com (Recommended)</a></p>
                        {/* <h3>Skype</h3>
                        <p>shakil.cse.ieee</p> */}
                        <h3>Social</h3>
                        <div className='social-icon'>
                            <a className="icon2" href="https://www.facebook.com/mdshakilahmed8" target="_blank" rel="noopener noreferrer"><AiFillFacebook /></a>
                            <a className="icon2" href="https://www.linkedin.com/in/mdshakilahmed8/" target="_blank" rel="noopener noreferrer"><AiFillLinkedin /></a>
                        </div>
                        <h3>Permanent Address</h3>
                        <address>
                            <p>Nawaber Tambu, Khonjor, Atrai, Naogaon-6596</p>
                        </address>
                        <h3>Present Address</h3>
                        <address>
                            <p>Baunia Bazar, Turag, Uttara, Dhaka-1230</p>
                        </address>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Contact;